import { render } from "./FavoriteBinanceNewUi.vue?vue&type=template&id=5ee8abc4&scoped=true"
import script from "./FavoriteBinanceNewUi.vue?vue&type=script&lang=js"
export * from "./FavoriteBinanceNewUi.vue?vue&type=script&lang=js"

import "./FavoriteBinanceNewUi.vue?vue&type=style&index=0&id=5ee8abc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee8abc4"]])

export default __exports__